"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
/**
 * String utilities
 */
var StringUtils;
(function (StringUtils) {
    function normalize(str) {
        return str.trim().toLocaleLowerCase();
    }
    StringUtils.normalize = normalize;
})(StringUtils = exports.StringUtils || (exports.StringUtils = {}));
//# sourceMappingURL=string.js.map